import m from 'mithril'

export default {
  view: vnode => {
    const glacier = require('./glacier.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-22-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
        <figure className="log-book-figure">
            <img src={glacier} className="log-book-img" />
          </figure>
          <figcaption className="log-book-figcaption">
          Artikel om Camp Century i The Saturday Evening Post, September 1960
            </figcaption>

        <h3 className="log-book-text mod-h3">Uddrag fra artikel sendt til godkendelse i Danmark:</h3>

        <p className="log-book-text">“I fremtiden kan lignende arktiske tunnelklynger huse raketbatterier, der kan nedskyde fjendtlige bombemaskiner og ICBM’er på vej hen over Nordpolen mod De Forenede Stater. De kan også huse fly og luftbårne faldskærmsenheder, der har til opgave at ødelægge affyringsramper og brintbombe depoter i en aggressor stat, eller amerikanske langtrækkende missiler, der er parate til øjeblikkelig gengældelse. Usynlige for både radio- og radarudstyr, men konstant spændt som et knockout-slag, kan de alvorligt afskrække ethvert magtsygt udenlandsk regime, der tænker på at iværksætte et nyt Pearl Harbor. Nogle optimister mener endda, at disse arktiske tunnelers eksistens vil kunne forhindre tredje verdenskrig.”</p>

        <p className="log-book-text">Samme afsnit bragt i The Saturday Evening Post efter ‘kommentarer’ fra Danmark: </p>

        <p className="log-book-text">“i fremtiden vil de erfaringer, vi gør i Camp Century, kunne anvendes i andre arktiske områder, hvis der skulle opstå et behov for at anlægge yderligere varslings- og luftforsvars faciliteter på steder, hvor større operationer i øjeblikket er umuligt.” </p>
        </div>
      </div>
    )
  }
}
